import React from 'react';
import { Link } from 'react-router-dom';
import { useTemporada } from '../context/TemporadaContext';
import { usePantallas } from '../context/PantallasContext';
import { useAuth } from '../context/AuthContext';
import { RUTA_ALTA_USUARIO, RUTA_PANEL_PANTALLAS } from '../utils/pantallas';

const NAV_ITEMS = [
  { to: '/dashboard/ranking',        label: 'Ranking' },
  { to: '/dashboard/equipos',        label: 'Equipos' },
  { to: '/dashboard/jugadores',      label: 'Jugadores' },
  { to: '/dashboard/jornadas',       label: 'Jornadas' },
  { to: '/dashboard/calendario',     label: 'Calendario' },
  { to: '/dashboard/form',           label: 'Introducir resultado' },
  { to: '/dashboard/competicion-2',  label: 'Competición' },
  { to: '/dashboard/temporadas',     label: 'Temporadas' },
];

function Dashboard() {
  const { temporada } = useTemporada();
  const { esVisible } = usePantallas();
  const { usuario } = useAuth();
  const tarjetas = NAV_ITEMS.filter(({ to }) => esVisible(to));
  if (usuario?.rol === 'ADMIN') {
    tarjetas.push({ to: RUTA_PANEL_PANTALLAS, label: 'Pantallas' });
    tarjetas.push({ to: RUTA_ALTA_USUARIO, label: 'Alta de usuarios' });
  }

  return (
    <div className="dashboard-home">
      <header className="dashboard-main-header">
        <h2>Bienvenida a la Liga</h2>
        {temporada && (
          <span className="dashboard-badge">{temporada}</span>
        )}
      </header>

      <p className="dashboard-intro">
        Selecciona una sección en el menú lateral para gestionar la competición.
      </p>

      <div className="dashboard-cards">
        {tarjetas.map(({ to, label }) => (
          <Link key={to} to={to} className="dashboard-card">
            <span>{label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
